<app-workspace-master-detail [detailOpen]="detailOpen">
  <div workspace-master class="ro-master workspace-page">
    <!-- The same segmented control the Leads collection uses. It takes its
         entries as an input, so what differs between the two collections is
         the list of views and nothing else. -->
    <app-leads-view-switcher class="ro-switcher" [entries]="views">
    </app-leads-view-switcher>

    <app-rolloff-board *ngIf="showBoard"
                       (detailRequested)="openDetail($event)"></app-rolloff-board>

    <app-rolloff-list class="workspace-page__panel" *ngIf="!showBoard" [stages]="context.stages"
                      (open)="openDetail($event)"></app-rolloff-list>
  </div>

  <div workspace-detail class="workspace-page--full">
    <router-outlet (deactivate)="reviewClosed($event)"></router-outlet>
    <app-rolloff-hire-detail [hidden]="detailId === null"
                             [hireId]="detailId"
                             [stages]="context.stages"
                             [reps]="context.reps"
                             [canManage]="canManage"
                             (closed)="closeDetail()"
                             (edit)="editHire($event)">
    </app-rolloff-hire-detail>
  </div>
</app-workspace-master-detail>
